import styled from 'styled-components' 

export default styled.div`
    background-color:black;
    margin-bottom: 0;
`;